import styled from 'styled-components';
import { Spacing16 } from 'autogen/design-tokens/tokens';
import { removeListStyling } from 'modules/helpers/mixins';
import type { TypeLinkDetailed } from 'types/autogen/contentful';
import RelatedArticle from './RelatedArticle';

// #region Styles
const ListOfRelatedArticles = styled.ul`
    display: flex;
    flex-direction: column;
    gap: ${Spacing16};
    ${removeListStyling};
`;

// #endregion Styles

export default function RelatedArticlesList({ relatedArticles }: { relatedArticles: TypeLinkDetailed[] }) {
    return (
        <ListOfRelatedArticles>
            {relatedArticles.map((relatedArticle) => {
                if (!relatedArticle) return null;

                return (
                    <li key={relatedArticle?.sys.id}>
                        <RelatedArticle {...relatedArticle} />
                    </li>
                );
            })}
        </ListOfRelatedArticles>
    );
}
